import { Action, Reducer } from 'redux';
import { AppThunkAction } from '.';
import { map, forEach, filter, orderBy } from 'lodash';
import update from 'immutability-helper';
import { PersonalAccountAvailableEquipment, PersonalAccountInformation } from '../models/AccountModels';
import { NotificationTypeEnum, NotificationToast } from '../models/NotificationModels'
import { ClientProcessingService, MobileService, ProcessingServiceStatusEnum, } from '../models/ServiceModels'
import { ToastNotificationManager } from '../infrastructure/ToastNotificationManager'
import { ApiResponseHelper } from '../infrastructure/utils/ApiResponseHelper'
import { AccountManagerRequests } from '../apiRequests/AccountManagerRequests';
import { ServicesRequests } from '../apiRequests/ServicesRequests';
import {  CreateMainContactCommand } from '../models/ClientManagerModels';
import { AppealRequests } from '../apiRequests/AppealRequests';
import { AlarmEnum } from '../models/GenericModels';
import { TubeTaskTagTemplete } from '../models/AppealModels';


export interface AccountStateState {
    isLoading: boolean;
    isExistsMainContact: boolean;
    accounts: PersonalAccountInformation[];
    selectedAccount: number;
    attachIsOpen: boolean;
    AccountsLenght_Resize: () => void;
    registrationHintShow: boolean;
    accountsAvailableEquipments: PersonalAccountAvailableEquipment[];
    equipmentIsLoading: boolean;
    tubeTaskTagTemplete: TubeTaskTagTemplete | null;
}


export interface InitAccountStateAction {
    type: 'INIT_ACCOUNT_LIST';
}

export interface UnMountAccountStateAction {
    type: 'UNMOUNT_ACCOUNT_LIST';
}

export interface InitAccountLenghtResize {
    type: 'INIT_ACCOUNT_LENGHT_RESIZE';
    AccountsLenght_Resize: () => void;
}

export interface ReceivePersonalAccountInformationAction {
    type: 'RECEIVE_ACCOUNT_INFORMATION';
    accounts: PersonalAccountInformation[];

}

export interface ReceiveChekingPersonalAccountAction {
    type: 'RECEIVE_CHEKING_PERSONAL_ACCOUNT';
    isExistsMainContact: boolean;
}

export interface UpdateAttachedAccounts {
    type: 'UPDATE_ATTACHED_ACCOUNTS';
    accounts: PersonalAccountInformation[];
}


export interface SelectedAccount {
    type: 'SET_SELECTED_ACCOUNT';
    selectedAccount: number
}

export interface AttachIsOpen {
    type: 'SET_ATTACH_OPEN';
    attachIsOpen: boolean
}

export interface  CreateMainContactAction {
    type: 'CREATE_MAIN_CONTACT';
    isExistsMainContact: boolean
}


export interface RegistrationHintClose {
    type: 'REGISTRATION_HINT_CLOSE';

}

export interface ReciveAvailableEquipmentAction {
    type: 'RECIVE_AVAILABLE_EQUIPMENT';
    accountsAvailableEquipments: PersonalAccountAvailableEquipment[]

}

export interface ReciveTubeTaskTagTempleteAction {
    type: 'RECIVE_TUBE_TASK_TAG_TEMPLATE';
    tubeTaskTagTemplete: TubeTaskTagTemplete

}




const apiAccountManagerRequests = new AccountManagerRequests();
const apiServicesRequest = new ServicesRequests();
const apiAppealRequests = new AppealRequests();

type KnownAction = InitAccountStateAction | UnMountAccountStateAction
    | ReceivePersonalAccountInformationAction |
    ReceiveChekingPersonalAccountAction | UpdateAttachedAccounts | SelectedAccount
    | AttachIsOpen |  CreateMainContactAction | InitAccountLenghtResize | RegistrationHintClose | ReciveAvailableEquipmentAction | ReciveTubeTaskTagTempleteAction;


export const actionCreators = {

    InitAccountStateAction: (): AppThunkAction<KnownAction> => async (dispatch, getState) => {
        apiAccountManagerRequests.Init();
        apiServicesRequest.Init();

        dispatch({
            type: 'INIT_ACCOUNT_LIST',
        });

    },
    UnMountAccountStateAction: (): AppThunkAction<KnownAction> => async (dispatch, getState) => {
        dispatch({
            type: 'UNMOUNT_ACCOUNT_LIST',
        });

    },

    GetAccountsStateAction: (): AppThunkAction<KnownAction> => async (dispatch, getState) => {

        let accountsList = await apiAccountManagerRequests.GetAttachPersonalAccount();
        let isExistsMainContact = await apiAccountManagerRequests.IsExistsMainContact();

        if (!accountsList.result) {
            let notificationError: NotificationToast = {
                type: NotificationTypeEnum.danger,
                message: `Получение добавленных лицевых счетов. ${ApiResponseHelper.GetErrorMessage(accountsList.error)}`,
                additionalMessage: ApiResponseHelper.GetErrorGuid(accountsList.error)
            }
            ToastNotificationManager.SendToast(notificationError);
            dispatch({
                type: 'RECEIVE_ACCOUNT_INFORMATION',
                accounts: []
            });
            return;
        }
        if (accountsList.data.length < 1) {
            dispatch({
                type: 'RECEIVE_ACCOUNT_INFORMATION',
                accounts: []
            });
            dispatch({
                type: 'RECEIVE_CHEKING_PERSONAL_ACCOUNT',
                isExistsMainContact: isExistsMainContact.data
            });
            return;
        }

        let accountsData = await Promise.all(map(accountsList.data, item => apiAccountManagerRequests.GetPersonalAccountInformation(item)));
        accountsData.forEach((element, index) => {
            if (element.result !== true) {
                let notificationError: NotificationToast = {
                    type: NotificationTypeEnum.danger,
                    message: `Не удалось получить информацию по ЛС ${accountsList.data[index]}`,
                }
                ToastNotificationManager.SendToast(notificationError);
            }
        })

        let accounts = map(filter(accountsData, item => item.data !== null), item => item.data as PersonalAccountInformation);

        /* accounts[2].services.push({
             serviceId: "string;,",
             serviceName: "Видеосервисы",
             serviceFullName: "Видеосервисы",
             status: "Активна",
             price: 20,
             volume: 20,
             discount: 20,
             amount: 20,
             isActive: true,
             serviceStatusAlarm: AlarmEnum.Danger,
             debitorCategoryAlarm: AlarmEnum.Danger,
             debitorCategory: "",
 
             //Подписки
             isRenewal: true,
             DateStart: new Date(),
             DateEnd: new Date(),
             DateRenewal: new Date(),
         })
         console.log(accounts)*/


        let availableServices = await Promise.all(accountsList.data.map((element, index) => { return apiServicesRequest.GetAvailableMobileServices(element) }))
        availableServices.forEach((element, index) => {
            let currentIndex = accounts.findIndex(el => el.balance.personalAccountId === element.personalAccountId);
            if (currentIndex !== -1)
                accounts[currentIndex].availableServices = element.response.data
        })

        let shortAppeals = await Promise.all(accountsList.data.map((element, index) => { return apiAppealRequests.GetAccountAppeals(element) }))
        shortAppeals.forEach((element, index) => {
            let currentIndex = accounts.findIndex(el => el.balance.personalAccountId === element.personalAccountId);
            if (currentIndex !== -1)
                accounts[currentIndex].appeals = element.response.data
        })

        let processingServices = await Promise.all(accountsList.data.map((element, index) => { return apiServicesRequest.GetProcessingServices(element) }))
        processingServices.forEach((element, index) => {
            let currentIndex = accounts.findIndex(el => el.balance.personalAccountId === element.personalAccountId);
            if (currentIndex !== -1)
                accounts[currentIndex].processingServices = element.response.data
        })

        let tubeTaskTagTemplete = await apiAppealRequests.GetTubeTaskTagTemplete();
        if (tubeTaskTagTemplete.result && tubeTaskTagTemplete.data !== null)
            dispatch({
                type: 'RECIVE_TUBE_TASK_TAG_TEMPLATE',
                tubeTaskTagTemplete: tubeTaskTagTemplete.data
            });


        dispatch({
            type: 'RECEIVE_ACCOUNT_INFORMATION',
            accounts: orderBy(accounts, item => item.balance.dateAttach)
        });

        dispatch({
            type: 'RECEIVE_CHEKING_PERSONAL_ACCOUNT',
            isExistsMainContact: isExistsMainContact.data
        });

        let availableEquipments = await Promise.all(accountsList.data.map((element, index) => { return apiAccountManagerRequests.GetAvailableEquipments(element) }))
        let reciveAvailableEquipment: PersonalAccountAvailableEquipment[] = [];
        availableEquipments.forEach((e, i) => {
            let currentIndex = accounts.findIndex(el => el.balance.personalAccountId === e.personalAccountId);
            if (currentIndex !== -1)
                reciveAvailableEquipment.push({ personalAccountId: e.personalAccountId, availableEquipment: e.response.data })
        })
        dispatch({
            type: 'RECIVE_AVAILABLE_EQUIPMENT',
            accountsAvailableEquipments: reciveAvailableEquipment
        });


    },


    AddAttachedAccountAction: (personalAccountId: string): AppThunkAction<KnownAction> => async (dispatch, getState) => {
        let accounts = getState().AccountState?.accounts || [];

        let newAccount = await apiAccountManagerRequests.GetPersonalAccountInformation(personalAccountId)
        let availableServices = await apiServicesRequest.GetAvailableMobileServices(personalAccountId);
        let processingServices = await apiServicesRequest.GetProcessingServices(personalAccountId);
        let shortAppeals = await apiAppealRequests.GetAccountAppeals(personalAccountId);
        let availableEquipment = await apiAccountManagerRequests.GetAvailableEquipments(personalAccountId);
        if (newAccount.result === false || availableServices.response.result === false || newAccount.data === null || shortAppeals.response.result === false) {

            return;
        }
        else {

            newAccount.data.availableServices = availableServices.response.data;
            newAccount.data.appeals = shortAppeals.response.data;
            newAccount.data.processingServices = processingServices.response.data;
        }

        let newAccounts = update(accounts, {
            $push: [newAccount.data]
        })
        dispatch({
            type: 'UPDATE_ATTACHED_ACCOUNTS',
            accounts: newAccounts,
        });

        if (availableEquipment.response.result !== false) {
            let newAvailableEquipments = update(getState().AccountState?.accountsAvailableEquipments || [],
                { $push: [{ personalAccountId: availableEquipment.personalAccountId, availableEquipment: availableEquipment.response.data }] })
            dispatch({
                type: 'RECIVE_AVAILABLE_EQUIPMENT',
                accountsAvailableEquipments: newAvailableEquipments
            });
        }

        getState().AccountState?.AccountsLenght_Resize();

    },

    UpdateAccountAppealsAction: (personalAccountId: string): AppThunkAction<KnownAction> => async (dispatch, getState) => {
        let newAccounts = getState().AccountState?.accounts.slice() || [];
        let index = newAccounts.findIndex(e => e.balance.personalAccountId === personalAccountId);

        if (index !== -1) {
            let response = await apiAppealRequests.GetAccountAppeals(personalAccountId);
            if (response.response.result)
                newAccounts[index].appeals = response.response.data
        }

        dispatch({
            type: 'UPDATE_ATTACHED_ACCOUNTS',
            accounts: newAccounts,
        });

    },

    UpdateAccountAppealQualityAction: (taskTagId: string, quality: number): AppThunkAction<KnownAction> => async (dispatch, getState) => {
        let newAccounts = getState().AccountState?.accounts.slice() || [];
        let accountIndex = getState().AccountState?.selectedAccount || 0;
        let index = newAccounts[accountIndex].appeals.findIndex(e => e.taskTagId === taskTagId);
        if (index !== -1) {
            newAccounts[accountIndex].appeals[index].quality = quality
        }

        dispatch({
            type: 'UPDATE_ATTACHED_ACCOUNTS',
            accounts: newAccounts,
        });

    },

    UnAttachAccountAction: (personalAccountId: string): AppThunkAction<KnownAction> => async (dispatch, getState) => {
        dispatch({
            type: "SET_SELECTED_ACCOUNT",
            selectedAccount: 0
        })
        let response = await apiAccountManagerRequests.UnAttachPersonalAccount(personalAccountId);
        if (response.result) {
            let accounts = getState().AccountState?.accounts || [];
            let findIndexAccount = accounts.findIndex(item => item.balance.personalAccountId === personalAccountId);
            let newAccounts = update(accounts, {
                $splice: findIndexAccount >= 0 ? [[findIndexAccount, 1]] : []
            })

            await dispatch({
                type: 'UPDATE_ATTACHED_ACCOUNTS',
                accounts: newAccounts,
            });
            getState().AccountState?.AccountsLenght_Resize();
        }
    },
    SelectAccountAction: (selectedAccount: number): AppThunkAction<KnownAction> => async (dispatch, getState) => {

        dispatch({
            type: 'SET_SELECTED_ACCOUNT',
            selectedAccount: selectedAccount
        });
    },

    SetAttachOpen: (attachIsOpen: boolean): AppThunkAction<KnownAction> => async (dispatch, getState) => {

        dispatch({
            type: 'SET_ATTACH_OPEN',
            attachIsOpen: attachIsOpen
        });
    },


    MobileServiceStatusUpdateAction: (service: ClientProcessingService): AppThunkAction<KnownAction> => async (dispatch, getState) => {

        if (service.status === ProcessingServiceStatusEnum.Activation || service.status === ProcessingServiceStatusEnum.Complete) {
            let accountsList = await apiAccountManagerRequests.GetAttachPersonalAccount();
            if (!accountsList.result) {
                let notificationError: NotificationToast = {
                    type: NotificationTypeEnum.danger,
                    message: `Получение добавленных лицевых счетов. ${ApiResponseHelper.GetErrorMessage(accountsList.error)}`,
                    additionalMessage: ApiResponseHelper.GetErrorGuid(accountsList.error)
                }
                ToastNotificationManager.SendToast(notificationError);
                return;
            }
            if (accountsList.data.length < 1) {
                dispatch({
                    type: 'RECEIVE_ACCOUNT_INFORMATION',
                    accounts: []
                });
                return;
            }
            let accountsData = await Promise.all(map(accountsList.data, item => apiAccountManagerRequests.GetPersonalAccountInformation(item)));
            accountsData.forEach((element, index) => {
                if (element.result !== true) {
                    let notificationError: NotificationToast = {
                        type: NotificationTypeEnum.danger,
                        message: `Не удалось получить информацию по ЛС ${accountsList.data[index]}`,
                    }
                    ToastNotificationManager.SendToast(notificationError);
                }
            })

            let accounts = map(filter(accountsData, item => item.data !== null), item => item.data as PersonalAccountInformation);
            let availableServices = await Promise.all(accountsList.data.map((element, index) => { return apiServicesRequest.GetAvailableMobileServices(element) }))
            availableServices.forEach((element, index) => {
                let currentIndex = accounts.findIndex(el => el.balance.personalAccountId === element.personalAccountId);
                if (currentIndex !== -1)
                    accounts[currentIndex].availableServices = element.response.data
            })

            let shortAppeals = await Promise.all(accountsList.data.map((element, index) => { return apiAppealRequests.GetAccountAppeals(element) }))
            shortAppeals.forEach((element, index) => {
                let currentIndex = accounts.findIndex(el => el.balance.personalAccountId === element.personalAccountId);
                if (currentIndex !== -1)
                    accounts[currentIndex].appeals = element.response.data
            })

            let processingServices = await Promise.all(accountsList.data.map((element, index) => { return apiServicesRequest.GetProcessingServices(element) }))
            processingServices.forEach((element, index) => {
                let currentIndex = accounts.findIndex(el => el.balance.personalAccountId === element.personalAccountId);
                if (currentIndex !== -1)
                    accounts[currentIndex].processingServices = element.response.data
            })


            dispatch({
                type: 'RECEIVE_ACCOUNT_INFORMATION',
                accounts: orderBy(accounts, item => item.balance.dateAttach)
            });

            let availableEquipments = await Promise.all(accountsList.data.map((element, index) => { return apiAccountManagerRequests.GetAvailableEquipments(element) }))
            let reciveAvailableEquipment: PersonalAccountAvailableEquipment[] = [];
            availableEquipments.forEach((e, i) => {
                let currentIndex = accounts.findIndex(el => el.balance.personalAccountId === e.personalAccountId);
                if (currentIndex !== -1)
                    reciveAvailableEquipment.push({ personalAccountId: e.personalAccountId, availableEquipment: e.response.data })
            })
            dispatch({
                type: 'RECIVE_AVAILABLE_EQUIPMENT',
                accountsAvailableEquipments: reciveAvailableEquipment
            });
        }
        else {
            let accounts = getState().AccountState?.accounts;
            if (accounts !== undefined) {
                let accountIndex = -1;
                let serviceIndex = -1;
                accounts.forEach((e, i) => {
                    e.processingServices.forEach((el, ind) => {
                        if (el.processingServiceId === service.processingServiceId) {
                            accountIndex = i;
                            serviceIndex = ind;
                        }
                    })
                })
                if (accountIndex !== -1 && serviceIndex !== -1)
                    accounts[accountIndex].processingServices[serviceIndex] = service;
            }

            dispatch({
                type: 'RECEIVE_ACCOUNT_INFORMATION',
                accounts: orderBy(accounts, item => item.balance.dateAttach)
            });
        }
    },

    GetMobileServiceCurrentStatusAction: (personalAccountIndex: number): AppThunkAction<KnownAction> => async (dispatch, getState) => {
        let accounts = getState().AccountState?.accounts;
        if (accounts === undefined)
            return;
        let processingServices = await apiServicesRequest.GetProcessingServices(accounts[personalAccountIndex].balance.personalAccountId);
        if (!processingServices.response.result)
            return;
        else {
            accounts[personalAccountIndex].processingServices = processingServices.response.data;
        }

        dispatch({
            type: 'RECEIVE_ACCOUNT_INFORMATION',
            accounts: orderBy(accounts, item => item.balance.dateAttach)
        });
    },

    CreateMainContactAction: (contact:  CreateMainContactCommand): AppThunkAction<KnownAction> => async (dispatch, getState) => {
        let response = await apiAccountManagerRequests. CreateMainContact(contact);

        if (response.result) {
            ToastNotificationManager.SendToast({
                type: NotificationTypeEnum.success,
                message: `Данные привязаны успешно!`,
            });
            dispatch({
                type: 'CREATE_MAIN_CONTACT',
                isExistsMainContact: true
            });
        }
        else {
            ToastNotificationManager.SendToast({
                type: NotificationTypeEnum.danger,
                message: `Не удалось привязать контактные данные.`,
            });
        }
    },

    InitAccountLenghtResizeAction: (func: () => void): AppThunkAction<KnownAction> => async (dispatch, getState) => {
        dispatch({
            type: 'INIT_ACCOUNT_LENGHT_RESIZE',
            AccountsLenght_Resize: func
        });

    },

    RegistrationHintCloseAction: (): AppThunkAction<KnownAction> => async (dispatch, getState) => {
        dispatch({
            type: 'REGISTRATION_HINT_CLOSE',
        });

    },

};


const unloadedState: AccountStateState = {
    isLoading: false, accounts: [], isExistsMainContact: true,
    selectedAccount: 0, attachIsOpen: false, AccountsLenght_Resize: () => { }, registrationHintShow: false, accountsAvailableEquipments: [], equipmentIsLoading: false, tubeTaskTagTemplete: null
};

export const reducer: Reducer<AccountStateState> = (state: AccountStateState | undefined, incomingAction: Action): AccountStateState => {
    if (state === undefined) {
        return unloadedState;
    }

    const action = incomingAction as KnownAction;
    switch (action.type) {

        case 'RECEIVE_ACCOUNT_INFORMATION':
            return {
                ...state,
                isLoading: true,
                registrationHintShow: action.accounts.length === 0,
                accounts: action.accounts,
            }

        case 'RECEIVE_CHEKING_PERSONAL_ACCOUNT':
            return {
                ...state,
                isExistsMainContact: action.isExistsMainContact,

            };
        case 'UPDATE_ATTACHED_ACCOUNTS':
            return {
                ...state,
                accounts: action.accounts,

            };
        case 'SET_SELECTED_ACCOUNT':
            return {
                ...state,
                selectedAccount: action.selectedAccount
            };
        case 'SET_ATTACH_OPEN':
            return {
                ...state,
                attachIsOpen: action.attachIsOpen
            };

        case 'CREATE_MAIN_CONTACT':
            return {
                ...state,
                isExistsMainContact: action.isExistsMainContact
            };

        case 'INIT_ACCOUNT_LENGHT_RESIZE':
            return {
                ...state,
                AccountsLenght_Resize: action.AccountsLenght_Resize
            };
        case 'REGISTRATION_HINT_CLOSE':
            return {
                ...state,
                registrationHintShow: false
            };
        case 'RECIVE_AVAILABLE_EQUIPMENT':
            return {
                ...state,
                equipmentIsLoading: true,
                accountsAvailableEquipments: action.accountsAvailableEquipments
            };
        case 'RECIVE_TUBE_TASK_TAG_TEMPLATE':
            return {
                ...state,

                tubeTaskTagTemplete: action.tubeTaskTagTemplete
            };

        default:
            return state;
    }

};
